import page from "./page";
import publicPage from "./public-page";
import layout from "./layout";
import processOrders from "./process-orders";
import scrollAppbarPage from "./scroll-appbar-page";

export default {
  page,
  scrollAppbarPage,
  publicPage,
  layout,
  processOrders
};
